import { render, staticRenderFns } from "./MatchByMatch.vue?vue&type=template&id=3ef2d6c1&scoped=true&"
import script from "./MatchByMatch.vue?vue&type=script&lang=js&"
export * from "./MatchByMatch.vue?vue&type=script&lang=js&"
import style0 from "./MatchByMatch.vue?vue&type=style&index=0&lang=css&"
import style1 from "./MatchByMatch.vue?vue&type=style&index=1&id=3ef2d6c1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef2d6c1",
  null
  
)

export default component.exports